var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden"},[_c('el-form-item',{attrs:{"prop":"name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }